import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { UserForm } from 'components/Users/UserForm'
import { UserAccountFormFields, UserAccountSchema } from 'components/Users/UserAccountFormFields'
import { SuccessDialog } from 'components/Shared/Dialogs/SuccessDialog'
import { USERNAME_CONFLICT } from 'services/errorCodes'
import { createUser } from 'services'
import { HTTP_422_ERROR } from 'Constants'
import ApiError from 'constants/ApiError'
import { useErrorHandling } from 'context/errorHandling'
import { useNavigatePrevent } from 'context/navigatePrevent'
import { UserDetailsSchema } from '../validationSchema'
import styles from 'components/Shared/CrudComponents/SimpleForm.module.css'
import { useTranslation } from 'react-i18next'

const initialValues = {
  username: '',
  password: '',
  passwordConfirmation: '',
  role: null,
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
  branchId: null,
  departmentId: null,
  personalPhoneNumber: '',
  hash: ''
}

export function CreateUserForm () {
  const [createdDialogOpen, setCreatedDialogOpen] = useState(false)

  const history = useHistory()
  const { t } = useTranslation()
  const { handleError } = useErrorHandling()

  const { setNavigationUnlocked, setNavigationBlocked } = useNavigatePrevent()

  useEffect(() => {
      setNavigationBlocked()
    }, [setNavigationBlocked]
  )

  function handleSubmit ({ passwordConfirmation, ...values }) {
    createUser({
      ...values
    })
      .then(() => {
          setCreatedDialogOpen(true)
        }
      )
      .catch(error => handleError(error, {
        [HTTP_422_ERROR]: error?.response?.data?.errorCode === USERNAME_CONFLICT ?
          'notifications.error.usernameConflict' : ApiError.UnprocessableEntity
      }))
  }

  return <div>
    <SuccessDialog open={createdDialogOpen}
                   onClose={() => {
                     setCreatedDialogOpen(false)
                     setNavigationUnlocked()
                     history.push('/users')
                   }} content={'notifications.success.createdUser'}/>
    <UserForm
      validationSchema={UserAccountSchema.concat(UserDetailsSchema)}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      title={t('form.user.createTitle')}>
      <div className={styles.container}>
        <h2>{t('form.account.title')}</h2>
        <UserAccountFormFields/>
      </div>
    </UserForm>
  </div>
}
